import { Controller } from "@hotwired/stimulus";

import { post } from "../lib/http.js";
import { applyErrors, clearErrors, setFieldError } from "../lib/form.js";
import { showToast } from "../lib/toast.js";

/** Модалка «Написать нам» из подвала. */
export default class extends Controller {
  static targets = ["dialog", "form", "topic", "message", "submit"];

  /** Открывает модалку с чистой формой. */
  open(event) {
    event.preventDefault();
    this.reset();
    this.dialogTarget.showModal();
  }

  /** Закрывает модалку. Esc и клик по фону закрывают её сами. */
  close() {
    this.dialogTarget.close();
  }

  /** Отправляет сообщение в поддержку. */
  async submit(event) {
    event.preventDefault();
    clearErrors(this.element);

    const message = this.messageTarget.value.trim();
    if (!message) {
      setFieldError(this.messageTarget, "Напишите сообщение");
      return;
    }

    this.submitTarget.disabled = true;

    try {
      await post("/api/feedback/", { topic: this.topicTarget.value, message });
    } catch (error) {
      const shown = applyErrors(error.data, {
        topic: this.topicTarget,
        // «Тема не выбрана» сервер вешает на subject — поле, которое он
        // выводит из темы.
        subject: this.topicTarget,
        message: this.messageTarget,
      });
      if (!shown) setFieldError(this.messageTarget, error.message);
      return;
    } finally {
      this.submitTarget.disabled = false;
    }

    this.close();
    showToast("Сообщение отправлено, мы ответим на вашу почту.", "success");
  }

  /** Чистит форму и прошлые ошибки. */
  reset() {
    this.formTarget.reset();
    clearErrors(this.element);
    // form.reset() не порождает события input, а счётчик символов слушает его.
    this.messageTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }
}
